import React from 'react';
import {ITableProps} from "@ui/tableCustom/types/table";
import TableFeatures from "@ui/tableCustom/tableFeatures/TableFeatures";
import {usePaginationCustomWithFilters} from "@hooks/pagination/usePaginationCustomWithFilters";

function LocalFilters<T>({
                             isLoading,
                             isError,

                             mapperRowCb,
                             data,
                             fullColumns,
                             headColumns,
                             params,
                             headSideBar,
                             secondarySidebar,
                             disabled,
                             hasExport = true,
                             exportParams,
                             autoGenerateExportData = ['data'],
                             mapperColumnCb,
                             baseExportStyles,
                             headerExportContents,
                             initialStickyHeader,
                             generateExportExcelRowStylesCb,
                             generateExportExcelHeadColumnStylesCb,
                             changeExportSidebarSettings,
                             paginationProps,
                             localFiltersProps,
                             hasPdfExport,
                             sx,
                             lastTableRow,
                             menuSettingsTable,
                             hasModalFullScreen,
                         }: ITableProps<T>) {


    const {
        paginationData,
        totalPage,
    } = usePaginationCustomWithFilters({
        data,
        params,
        searchKeysArr: localFiltersProps?.searchKeysArr
    })


    return (
        <TableFeatures
            isLoading={isLoading}
            isError={isError}
            mapperRowCb={mapperRowCb}
            data={paginationData}
            fullColumns={fullColumns}
            headColumns={headColumns}
            params={params}
            disabled={disabled}
            hasExport={hasExport}
            exportParams={exportParams}
            autoGenerateExportData={autoGenerateExportData}
            mapperColumnCb={mapperColumnCb}
            baseExportStyles={baseExportStyles}
            headerExportContents={headerExportContents}
            initialStickyHeader={initialStickyHeader}
            headSideBar={headSideBar}
            secondarySidebar={secondarySidebar}
            hasExportDataFromAllPage
            allData={data}
            generateExportExcelRowStylesCb={generateExportExcelRowStylesCb}
            generateExportExcelHeadColumnStylesCb={generateExportExcelHeadColumnStylesCb}
            changeExportSidebarSettings={changeExportSidebarSettings}
            paginationProps={paginationProps}
            hasPdfExport={hasPdfExport}
            sx={sx}
            lastTableRow={lastTableRow}
            menuSettingsTable={menuSettingsTable}
            hasModalFullScreen={hasModalFullScreen}
            totalPage={totalPage}
        />
    )
}

export default LocalFilters;